module.exports = __webpack_public_path__ + "static/media/BreastCancer_FFE3922.c8b131f2.jpg";